import type { Usuario } from '../types/auth';
import type { EntidadDinero } from '../types/comprobante';

/** La entidad propia del usuario: la que entra en modo regularización y recibe sus avisos. */
export function entidadPropia(usuario: Usuario | null): EntidadDinero | null {
  const nivel = usuario?.rol?.nivel;
  if (nivel === 4 && usuario?.lumisial_id) {
    return { tipo: 'lumisial', id: usuario.lumisial_id, nombre: usuario.lumisial?.nombre ?? '' };
  }
  if (nivel === 3 && usuario?.diocesis_id) {
    return { tipo: 'diocesis', id: usuario.diocesis_id, nombre: usuario.diocesis?.nombre ?? '' };
  }
  if (nivel === 2 && usuario?.provincia_eclesiastica_id) {
    return { tipo: 'provincia', id: usuario.provincia_eclesiastica_id, nombre: '' };
  }
  return null;
}

export function rutaPanelPendientes(entidad: EntidadDinero): string {
  return entidad.tipo === 'lumisial'
    ? '/lumisial/balance/movimientos#comprobantes-pendientes'
    : '/admin/balance/movimientos#comprobantes-pendientes';
}

/** Parámetro que pide al panel de pendientes abrir la carga del comprobante objetado más antiguo (H23). */
export const PARAM_REEMPLAZAR = 'reemplazar';

/** El panel de pendientes con la carga del comprobante objetado más antiguo ya abierta. */
export function rutaReemplazarComprobante(entidad: EntidadDinero): string {
  const base = entidad.tipo === 'lumisial' ? '/lumisial/balance/movimientos' : '/admin/balance/movimientos';
  return `${base}?${PARAM_REEMPLAZAR}=1#comprobantes-pendientes`;
}

/** "en este Lumisial", "en esta diócesis", "en la nación". */
export function enLaEntidad(entidad: EntidadDinero): string {
  if (entidad.tipo === 'lumisial') return 'en este Lumisial';
  if (entidad.tipo === 'diocesis') return 'en esta diócesis';
  return 'en la nación';
}

interface ColumnasDeEntidad {
  readonly lumisial_id: string | null;
  readonly diocesis_id: string | null;
  readonly provincia_eclesiastica_id: string | null;
}

/** La entidad que guarda el comprobante de lo que registra una junta (fondo de una campaña, envío entre juntas). */
export function entidadDelOwnerDeCampana(owner: { readonly tipo: 'lumisial' | 'diocesis' | 'provincia'; readonly id: string; readonly nombre: string }): EntidadDinero {
  return { tipo: owner.tipo, id: owner.id, nombre: owner.nombre };
}

/** La entidad dueña de una fila que guarda una sola de las tres columnas de entidad (deuda, movimiento). */
export function entidadPorColumnas(fila: ColumnasDeEntidad): EntidadDinero | null {
  if (fila.lumisial_id) return { tipo: 'lumisial', id: fila.lumisial_id, nombre: '' };
  if (fila.diocesis_id) return { tipo: 'diocesis', id: fila.diocesis_id, nombre: '' };
  if (fila.provincia_eclesiastica_id) return { tipo: 'provincia', id: fila.provincia_eclesiastica_id, nombre: '' };
  return null;
}
